import styles from "./StaffLeaves.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import IconAndName from "../../components/IconAndName/IconAndName";
import { IoAddCircleOutline } from "react-icons/io5";
import { viewLeave } from "../../redux/slices/leaveSlice";
import CopyRight from "../../components/CopyRight/CopyRight";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

const data = [
  {
    _id: "gnswkgnseknsg1",
    staffName: "xtejkew4",
    appliedon: "2828",
    appliedtill: "468973925",
    leavetype: "staff@gmail.com",
    status: "done",
    reason: ["Transfer", "Delete"],
  },
];

function StaffLeaves() {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleaddLeave = () => {
    dispatch(openModal("newLeave"));
  };

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        staffName: <LogoWithName name={item.staffName} />,
        appliedon: item.appliedon,
        appliedtill: item.appliedtill,
        leavetype: item.leavetype,
        reason: item.reason,
        status: item.status,
        action: (
          <span
            onClick={() => {
              dispatch(viewLeave(item));
              dispatch(openModal("viewLeave"));
            }}
            style={{ color: "var(--Primary_Color)", cursor: "pointer" }}
          >
            View
          </span>
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Staff Name", accessor: "staffName" },
    { title: "Applied On", accessor: "appliedon" },
    { title: "Applied Till", accessor: "appliedtill" },
    { title: "Leave type", accessor: "leavetype" },
    { title: "Status", accessor: "status" },
    { title: "Reason", accessor: "reason" },
    { title: "Action", accessor: "action" },
  ];

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          {/* Status boxes */}
          <div className={styles.outsidedropdown}>
            <Dropdown
              label="Program"
              options={["Annual Day", "Freshers"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Group"
              options={["Group 1", "Group 2"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Room"
              options={["Room1", "Room2"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <IconAndName
              icon={<IoAddCircleOutline />}
              title="New Leave"
              bgColor="Primary_Color"
              onClick={handleaddLeave}
            />
          </div>

          {/* Search and Filters */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Staff"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.rightrow}>
                <div className={styles.dateWrapper}>
                  <CalendarInput
                    label="Select Date"
                    required
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    background="var(--Utility_Color1)"
                    placeholderColor="var(--Info_Color)"
                    iconColor="var(--Grey_Color)"
                    borderRadius="12px"
                  />
                </div>
                <Dropdown
                  label="All Staff"
                  options={["Student1", "Student2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Leave Type"
                  options={["1", "2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Status"
                  options={["approved", "waiting for action"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <div>{<CopyRight />}</div>
    </>
  );
}

export default StaffLeaves;
